module.exports = __webpack_public_path__ + "static/img/egg_r_22.93c3cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_22.png
// module id = RXtH
// module chunks = 1